import { BaseSerializer } from "./baseSerializer.ts";
import { NetworkResource } from "@models/networkResource.ts";

export class NetworkResourceSerializer extends BaseSerializer {
  public deserialize(data: any): NetworkResource {
    const gp = new NetworkResource();
    this._copyLayersAttributes(gp, data);
    return gp;
  }
}
